
import Component from './component';
var tealiumEnable = require('int_tealium_sfra/tealiumEnable');
var utils = require('../utils');
import swiperHelper from '../product/swiperHelper';

var carouselCTLinteraction;
var ctlinteraction = false;

/**
 * Recommendations component
 */
export default class Recommendations extends Component {
    constructor(...args) {
        super(...args);
        this.initialise();
        this.recoLoaded = false;
        this.trackingEnabled = this.el.dataset.tracking !== 'false';
        return this;
    }

    handleAttributeSelect(response, self) {
        let selectedProductID = (response.selectedAttrValue && response.data.product.masterProductData.ID) ? (response.data.product.masterProductData.ID + '-' + response.selectedAttrValue) : response.data.product.id;
        let CTSonColorSwatchEnable = document.getElementById('CTSonColorSwatchEnable');
        if (CTSonColorSwatchEnable && CTSonColorSwatchEnable.value === 'true') {
            if (response.attrId && response.attrId.toLowerCase() === 'colorcode') {
                this.$el.html('');
                this.$el.addClass('loading');
                const recommendationUrl = new URL(this.el.dataset.recommUrl, window.location.href);
                recommendationUrl.searchParams.set('pid', selectedProductID);
                this.el.dataset.url = recommendationUrl.toString();

                // check if the elememnt exists before using it as the new code does not load if its not required.
                const ctlModileCtaButton = document.getElementById('ctlMobileCtaButton');
                if (ctlModileCtaButton) {
                    document.getElementById('ctlMobileCtaButton').classList.add('d-none');
                }
            }
        }
    }

    initIntersection(targetEl) {
        const options = {
            root: null,
            rootMargin: '650px 0px 650px 0px', // Increased margin for observer to fire
            threshold: 0
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.dataset.url = entry.target.dataset.recommUrl;
                    observer.unobserve(entry.target);
                }
            });
        }, options);

        observer.observe(targetEl);
    }

    isHidden() {
        // TODO: Need architecture solution to avoid orphan component instances causing the code to run
        // even when component no more exists https://stackoverflow.com/questions/19669786/check-if-element-is-visible-in-dom
        return (this.el.offsetParent === null);
    }

    recommendationCtlMobile() {
        var CTA = document.getElementById('ctlMobileCtaButton');
        if (!CTA) return;

        var CTLTitle;
        if ($('h2.product-recommendation__title').length) {
            CTA.childNodes[0].nodeValue = '';
            CTLTitle = $('h2.product-recommendation__title').text();
            CTA.childNodes[0].nodeValue = CTLTitle;
            CTA.classList.remove('d-none');
        }
        CTA.addEventListener('click', function () {
            var scrollPad = 6; // Buffer for anchor scroll
            var CTLContainer = document.getElementsByClassName('recommendation-container');
            scrollTo(0, CTLContainer[0].offsetTop - scrollPad);
            CTLContainer[0].tabIndex = '0';
            CTLContainer[0].focus();
        });
    }

    onRecommendationLoaded() {
        if (this.isHidden()) return;
        window.PVH.mountAllComponents('quickView');

        if (this.trackingEnabled) {
            var recommendationTypeDiv = $('.recommendation-container div[data-recomtype]');
            var recommendationType = recommendationTypeDiv ? recommendationTypeDiv.data('recomtype') : '';
            tealiumEnable.getAnalyticsData('ctlContainerLoadEvent', recommendationType);
        }

        // check if the elememnt exists before using it as the new code does not load if its not required.
        const ctlModileCtaButton = document.getElementById('ctlMobileCtaButton');
        if (ctlModileCtaButton) {
            this.recommendationCtlMobile();
        }

        this.recoLoaded = true;
        this.updateCarouselClass();
    }

    updateCarouselClass() {
        const $carouselContainer = $('.recommendation-container.io.enabled .ctl-carousel');
        const $swiperWrapper = $('.recommendation-container.io.enabled .swiper-wrapper');

        let deviceType = utils.getCurrentBreakpoint() === 'mobile' ? 'mobile' : 'desktop';

        // Add .ctl-carousel on desktop and remove it on mobile/tablet
        if (deviceType === 'desktop') {
            if ($carouselContainer.hasClass('ctl-carousel')) {
                this.initCtlSwiper();
                $swiperWrapper.removeClass('row product-grid');
            }
        } else if ($('.recommendation-container.io.enabled .ctl-carousel.swiper-initialized').hasClass('swiper-initialized')) {
            this.destroySwiper();
            $swiperWrapper.addClass('row product-grid');
        }

        if (!$swiperWrapper.children().length) {
            $('h2.product-recommendation__title').hide();
        }
    }

    initCtlSwiper() {
        const $carouselCTL = $('.recommendation-container.io.enabled .ctl-carousel');
        swiperHelper.createSwiperCarousel($carouselCTL, {
            slidesPerView: 2,
            freeMode: true,
            pagination: false,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
                dragSize: '140px'
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            on: {
                slideChange: function () {
                    if (ctlinteraction == true) {
                            tealiumEnable.getAnalyticsData('ctlCarouselTracking', carouselCTLinteraction);
                            ctlinteraction = false;
                    }
                },
                scrollbarDragMove: function () {
                    ctlinteraction = true;
                    carouselCTLinteraction = 'product_ctl_image_carousel_scroll';
                }
            }
        });
    }

    destroySwiper() {
        const $carouselCTL = $('.recommendation-container.io.enabled .ctl-carousel');
        if ($carouselCTL.hasClass('swiper-initialized')) {
            $carouselCTL[0].swiper.destroy(true, true);
        }
    }

    updateProductTileUrl() {
        // Logic to update the REC url with master product and udpate all urls
        const $productTiles = $('.einsteinReco-wrapper__tile', this.el);
        if ($productTiles.length) {
            $productTiles.each((event, tile) => {
                const $productTile = $('.pdpurl', tile);
                const $productTileName = $('.ds-product-name', tile);
                let tileUrl = $productTile.attr('href');
                try {
                    // if master product exists then update it into the reco param of the URL
                    //  split the rec param value as this event gets called multiple times (Architecture problem)
                    const masterProduct = this.el.dataset.productId;
                    if (masterProduct) {
                        const tileUrlObj = new URL(`${location.origin}${tileUrl}`);
                        let recoParam = tileUrlObj.searchParams.get('rec');
                        recoParam = recoParam.split('_').splice(0, 4);
                        recoParam.push(masterProduct);
                        const updatedRec = `${recoParam.join('_')}`;
                        tileUrlObj.searchParams.set('rec', updatedRec);
                        tileUrl = tileUrlObj.toString();
                    }
                } catch (error) {}

                $productTile.attr('href', tileUrl);
                $productTileName.attr('href', tileUrl);
            });
        }
    }
    mobileGridSlot(parentElement) {
        const loadMoreButton = parentElement.find('.grid-load-more');
        const $slotTiles = parentElement.find('.einsteinReco-wrapper__slot-tile');
        const totalCount = utils.getCurrentBreakpoint() === 'mobile' ? $slotTiles.length - 4 : $slotTiles.length - 10;
        loadMoreButton.hide();
        loadMoreButton.find('span').text(totalCount);
        loadMoreButton.on('click', function () {
            parentElement.find('.hide-tile').removeClass('hide-tile');
            parentElement.removeClass('overlay-grid');
            loadMoreButton.hide();
        });

        $slotTiles.each((index, tile) => {
            if (index < 10) {
                $(tile).removeClass('hide-tile');
            }
        });

        if (utils.getCurrentBreakpoint() === 'mobile') {
            $slotTiles.each((index, tile) => {
                if (index >= 4) {
                    $(tile).addClass('hide-tile');
                }
            });
            if ($slotTiles.length > 4) {
                loadMoreButton.show();
                if (parentElement.hasClass('overlay')) {
                    parentElement.addClass('overlay-grid');
                }
            } else {
                parentElement.removeClass('overlay-grid');
            }
        } else if ($slotTiles.length > 10) {
            loadMoreButton.show();
            if (parentElement.hasClass('overlay')) {
                parentElement.addClass('overlay-grid');
            }
        } else {
            parentElement.removeClass('overlay-grid');
        }
    }

    initialise() {
        let self = this;
        let productRecoLoaded = false;
        if (!this.el.dataset.noUpdate) {
            $('body').on('product:afterAttributeSelect', (e, response) => this.handleAttributeSelect(response, self));
        }

        $('body').on('recommendation:loaded', () => {
            this.onRecommendationLoaded();
        });

        $('body').on('product-recommendation:loaded', function () {
            if (self.$el.hasClass('einstein-recommendation')) {
                var isCartPage = false;
                if (self.el.dataset.pagetype && self.el.dataset.pagetype === 'cart') {
                    isCartPage = true;
                }

                self.updateProductTileUrl();

                let productTilesCounter = self.$el.find('.einsteinReco-wrapper__tile').length;
                if (productTilesCounter >= 4) {
                    if (self.$el.hasClass('js-atcReco')) {
                        // Added condition to use Swiper for Add to Bag confirmation recommendation carousel
                        var $carousel = $('.js-atcReco .einsteinReco-wrapper__caro');
                        swiperHelper.createSwiperCarousel($carousel, {
                            slidesPerView: 3.2,
                            freeMode: true,
                            pagination: false,
                            on: {
                                slideChange: function () {}
                            },
                            breakpoints: {
                                768: {
                                    slidesPerView: 4.2,
                                    pagination: false,
                                    scrollbar: {
                                        el: '.swiper-scrollbar',
                                        draggable: true
                                    },
                                    mousewheel: true,
                                    keyboard: { enabled: true }
                                }
                            }
                        });
                    } else {
                        $('.einsteinReco-wrapper__caro', self.$el).not('.slick-initialized').slick({
                            autoplay: false,
                            rows: 0,
                            speed: 300,
                            dots: false,
                            infinite: false,
                            accessibility: true,
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            arrows: true,
                            slide: '.einsteinReco-wrapper__tile',
                            prevArrow:
                                '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="false" style=""><svg class="svg-arrow left" width="10.3" height="7.53" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.79889 0.238281L5.57358 0.238281L2.43633 3.37554L10.3333 3.37553V4.63044L2.43633 4.63044L5.57358 7.76769L3.79889 7.76769L0.0341797 4.00299L3.79889 0.238281Z" fill="black"/> </svg></button>',
                            nextArrow:
                                '<button class="slick-next slick-arrow slick-disabled" aria-label="Next" type="button" aria-disabled="true" style=""><svg class="svg-arrow right" width="10.3" height="7.53" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.20116 7.76769H5.42646L8.56371 4.63044L0.666748 4.63044L0.666748 3.37554L8.56371 3.37554L5.42646 0.238282L7.20116 0.238281L10.9659 4.00299L7.20116 7.76769Z" fill="black"/></svg></button>',
                            responsive: [
                                {
                                    breakpoint: 768,
                                    settings: {
                                        slidesToShow: isCartPage ? 3.4 : 1.4,
                                        slidesToScroll: 1
                                    }
                                }
                            ]
                        });
                    }
                    $('.einsteinReco-wrapper').removeClass('loading');
                    if (isCartPage) {
                        $('.atcComp__recommendations').addClass('atcReco-loaded');
                    }
                }
                if (self.$el.find('.einstein-slot-carousel').length) {
                    // Loop through each carousel and assign a unique ID/class
                    self.$el.find('.einsteinReco-wrapper__slot-caro.swiper').each(function (index) {
                        const swiperElement = $(this);
                        const uniqueId = 'swiper-carousel-' + index;
                        const prevClass = 'swiper-prev-' + index;
                        const nextClass = 'swiper-next-' + index;

                        // Add the unique classes to the navigation buttons
                        $(this).find('.swiper-button-prev').addClass(prevClass);
                        $(this).find('.swiper-button-next').addClass(nextClass);

                        // Add the unique target for navigation per carousel
                        let next = '.' + nextClass;
                        let prev = '.' + prevClass;

                        swiperElement.addClass(uniqueId);
                        const targetElement = $('.' + uniqueId);
                        swiperHelper.createSwiperCarousel(targetElement, {
                            slidesPerView: 2.5,
                            freeMode: true,
                            pagination: false,
                            lazy: {
                                loadPrevNext: true,
                                loadPrevNextAmount: 2
                            },
                            scrollbar: {
                                el: '.swiper-scrollbar',
                                draggable: true,
                                dragSize: '140px'
                            },
                            navigation: {
                                nextEl: next,
                                prevEl: prev
                            },
                            mousewheel: {
                                forceToAxis: true,
                                sensitivity: 1
                            },
                            breakpoints: {
                                768: {
                                    slidesPerView: 4.5
                                },
                                900: {
                                    slidesPerView: 6.5
                                }
                            }
                        });
                    });
                }

                if (self.$el.find('.einstein-slot-grid').length) {
                    self.$el.find('.einstein-slot-grid').each(function () {
                        self.mobileGridSlot($(this));
                    });
                }
                if (self.$el.find('.einstein-slot-grid.overlay').length) {
                    self.$el.find('.einstein-slot-grid.overlay').each(function () {
                        self.mobileGridSlot($(this));
                    });
                }
            }
            window.PVH.mountAllComponents('quickView');

            if (self.el.dataset.showspinner) {
                self.$el.spinner().stop();
            }
        });

        if (this.el.dataset.observe && !productRecoLoaded) {
            self.initIntersection(this.el);
            productRecoLoaded = true;
        }

        if (document.getElementsByClassName('product-recommendation__tile-wrapper').length) {
            // First time load - Check and trigger with a delay to make sure recommendationLoaded if fired
            // If the component is already loaded This gives the actual event to fire time
            // and if not this kicks in after 1 sec.
            setTimeout(() => {
                if (!this.recoLoaded) {
                    this.onRecommendationLoaded();
                }
            }, 500);
        }

        $('.ctl-carousel .swiper-button-next, .ctl-carousel .swiper-button-prev').on('click', function () {
            ctlinteraction = true;
            carouselCTLinteraction = 'product_ctl_image_carousel_arrowclick';
        });
    }

    enable() {
        if (this.state.data) {
            this.$el.html(this.state.data);
            if (this.el.dataset.showspinner) {
                this.$el.spinner().start();
            }
            setTimeout(() => {
                this.$el.removeClass('loading');
                if (this.el.dataset.showspinner) {
                    this.$el.spinner().stop();
                }
            }, 1500);
        }
    }
    onResize() {
        this.updateCarouselClass();
        if (this.$el.find('.einstein-slot-grid').length) {
            this.$el.find('.einstein-slot-grid').each((index, element) => {
                this.mobileGridSlot($(element));
            });
        }
        if (this.$el.find('.einstein-slot-grid.overlay').length) {
            this.$el.find('.einstein-slot-grid.overlay').each((index, element) => {
                this.mobileGridSlot($(element));
            });
        }
    }
}
